<ws-modal-wrapper
    [headerLabel]="headerLabel"
    acceptLabel="Save"
    cancelLabel="Cancel"
    acceptClass="btn-primary"
    cancelClass="btn-outline-primary"
    [disableSave]="disableSave"
    [disableCancel]="loading"
    [loading]="loading"
    (save)="save()"
    (cancel)="cancel()"
>
    <div class="bulk-update-form">
        @if (params.canRereview) {
            <div class="field-label">
                <label for="review-status">Review Status:</label>
            </div>
            <div>
                <select id="review-status" class="form-select" [(ngModel)]="reviewUpdate" [disabled]="loading">
                    <option value="no-change">No Change</option>
                    <option value="rereviewed">Rereviewed</option>
                </select>
            </div>
            <div class="review-help">
                <p
                    >Some payments may not move forward because a parcel or collector may have changed after the review
                    task was completed.</p
                >
                <p
                    >After confirming the changes do not affect the payment, you can mark the task as rereviewed to
                    clear the error.</p
                >
            </div>
        }

        @if (params.canChangeApprover) {
            <div class="field-label">
                <label for="approver-update">Approver:</label>
            </div>
            <div>
                <select id="approver-update" class="form-select" [(ngModel)]="approverUpdate" [disabled]="loading">
                    <option value="no-change">No Change</option>
                    <option value="change">Change</option>
                </select>
            </div>
            <div class="approver-picker">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Search approver..."
                    [ngModel]="selectedDisplayName"
                    (ngModelChange)="onApproverTextChanged($event)"
                    [wsTypeahead]="candidates"
                    typeaheadOptionField="displayName"
                    [typeaheadMinLength]="0"
                    [typeaheadScrollable]="true"
                    [typeaheadOptionsLimit]="100"
                    container="body"
                    (typeaheadOnSelect)="onApproverSelected($event)"
                    [disabled]="loading || approverUpdate !== 'change' || candidates.length === 0"
                />

                <label class="all-contacts">
                    <input
                        type="checkbox"
                        [(ngModel)]="includeAllCompanyContacts"
                        (change)="onIncludeAllCompanyContactsChanged()"
                        [disabled]="loading || approverUpdate !== 'change'"
                    />
                    <span>All Eligible Company Contacts</span>
                </label>

                @if (!loading && approverUpdate === 'change' && candidates.length === 0) {
                    <div class="text-muted mt-2">No eligible payment approvers were found.</div>
                }
            </div>
        }
    </div>
</ws-modal-wrapper>
